import React from 'react';
import { Link } from 'react-router-dom';
import why_work from '../../../assets/images/why-work.png';
import { Navigate } from 'react-router-dom';
import CustomModalView from '../../../common/input/customModal/customModalView';

const RegistrationSelectionView = (props) => {
  return (
    <>
      <section className="login-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 login-center">
              <div className="login-form-main">
                <div className="registration-form_wrapper">
                  <div className="content">
                    <img src={why_work} alt="" />
                    <h3>carerconnect</h3>
                    <h4>Whenever Wherever</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 login-center">
              <div className="login-form-main">
                <h3 style={{ color: 'white', marginBottom: '20px' }}>
                  Select Registration Type
                </h3>
                <div
                  className="registration-form_wrapper"
                  style={{ padding: '62px 80px' }}
                >
                  <div className="content">
                    <div
                      className="login-form"
                      style={{ width: 'auto', margin: '0px', padding: '0px' }}
                    >
                      <form>
                        <div className="field-box">
                          {/* <Link href="/user/registration/#applicant"> */}
                            <button
                              type="button"
                              className="btn btn-red regular"
                            >
                              Register as Applicant{' '}
                              <i className="fa fa-user" aria-hidden="true"></i>
                            </button>
                          {/* </Link> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="login-form-main">
                <div
                  className="registration-form_wrapper"
                  style={{ padding: '62px 80px' }}
                >
                  <div className="content">
                    <div
                      className="login-form"
                      style={{ width: 'auto', margin: '0px', padding: '0px' }}
                    >
                      <form>
                        <div className="field-box">
                          {/* <Link href="/user/registration/#employer"> */}
                            <button
                              type="button"
                              className="btn btn-red regular"
                            >
                              Register as Employer{' '}
                              <i
                                className="fa fa-suitcase"
                                aria-hidden="true"
                              ></i>
                            </button>
                          {/* </Link> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CustomModalView
        modal_show={props.modal_show}
        authResponse={props.authResponse}
        showCustomModal={props.showCustomModal}
        hideCustomModal={props.hideCustomModal}
        custom_model={props.custom_model}
      />
    </>
  );
};

export default RegistrationSelectionView;
